import { useRef } from 'react'
import { Field } from 'react-final-form'

import { FormControl } from '@elements/form-control'
import { nanoid } from '@utils/strings'

export type FormFieldProps<P> = Omit<P, 'value' | 'onChange'> & {
  name: string
  label?: string
  description?: string
  component: React.FC<P>
}

export function FormField<P>({
  name,
  label,
  description,
  component: Component,
  ...componentProps
}: FormFieldProps<P>) {
  const fieldNameId = useRef(`${name}-${nanoid()}`)
  const _componentProps = componentProps as P
  return (
    <Field name={name}>
      {({ input, meta }) => {
        const hasError: boolean = meta.touched && meta.invalid && meta.error
        return (
          <FormControl
            name={fieldNameId.current}
            label={label}
            description={description}
            error={hasError && meta.error}
          >
            <Component
              {..._componentProps}
              id={fieldNameId.current}
              name={input.name}
              error={hasError}
              value={input.value}
              onChange={input.onChange}
            />
          </FormControl>
        )
      }}
    </Field>
  )
}
